import { render } from "./Register.vue?vue&type=template&id=2b5dc07c"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__